import fetch from 'isomorphic-fetch'

const API_URL_AVT = process.env.REACT_APP_AVT_API_URL

const createRequestBody = (requestObj) => {
  return {
    method: requestObj.method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: requestObj.Authorization
    },
    body: JSON.stringify(requestObj.body)
  }
}

const getFlags = async (jobId) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/flags`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}
const changeOptimalStartTask = async (taskID, newStartDate) => {
  const requestUrl = `${API_URL_AVT}/nebula/tasks/${taskID}/update-optimals`
  let headers = {
    method: 'PUT'
  }
  if (newStartDate) {
    headers.body = {
      start_time: newStartDate
    }
  }

  let requestBody = createRequestBody(headers)
  return fetch(requestUrl, requestBody)
}

const resolveFlag = async (flagId, comment) => {
  const requestUrl = `${API_URL_AVT}/odin/api/flag/${flagId}/resolve`

  let headers = {
    method: 'PUT'
  }
  if (comment) {
    headers.body = {
      params: {
        comment
      }
    }
  }
  let requestBody = createRequestBody(headers)
  return fetch(requestUrl, requestBody)
}

const getHistory = async (jobId) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/history`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const resetTask = async (jobId, taskId, comment) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/task/${taskId}/reset`

  let headers = {
    method: 'POST'
  }
  if (comment) {
    headers.body = {
      params: {
        comment
      }
    }
  }
  let requestBody = createRequestBody(headers)
  return fetch(requestUrl, requestBody)
}

const assignTask = async (jobId, taskId, resource) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/task/${taskId}/manualAssignation/${resource.id}`

  let headers = {
    method: 'POST',
    body: { resource }
  }
  let requestBody = createRequestBody(headers)
  return fetch(requestUrl, requestBody)
}

const reAssignTask = async (jobId, taskId, resource) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/task/${taskId}/proposeAssignation/${resource.id}`

  let headers = {
    method: 'POST',
    body: { resource }
  }
  let requestBody = createRequestBody(headers)
  return fetch(requestUrl, requestBody)
}

const resetDeliveryTries = async (jobId) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/resetDeliveryCodeTries`

  let headers = {
    method: 'POST'
  }
  let requestBody = createRequestBody(headers)
  return fetch(requestUrl, requestBody)
}

const blockingPolicyUnlock = async (jobId) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/unlock`

  let headers = {
    method: 'POST',
    body: {}
  }
  let requestBody = createRequestBody(headers)
  return fetch(requestUrl, requestBody)
}

const makeDelivery = async (jobId, taskId, stepId, comment) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/forceDelivery`

  let headers = {
    method: 'POST',
    body: {
      taskId,
      stepId,
      comment
    }
  }
  let requestBody = createRequestBody(headers)
  return fetch(requestUrl, requestBody)
}

const getPhotoUrl = async (jobId) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/generatePhotoUrl`

  const headers = {
    method: 'GET'
  }
  let requestBody = createRequestBody(headers)
  return fetch(requestUrl, requestBody)
}

const getInvoices = async (jobId) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/invoices`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const downloadInvoices = async (jobId) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/download`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}
const getDeliveryValidationsImages = async (jobId, imageType) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/images?imageType=${imageType}`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}
const downloadDeliveryValidationsImages = async (photoUrl, token) => {
  const requestUrl = `${API_URL_AVT}/odin/api/download-image?photoUrl=${photoUrl}`

  let requestBody = createRequestBody({
    method: 'GET',
    Authorization: `Bearer ${token}`
  })
  return fetch(requestUrl, requestBody)
}

const getUploadInvoiceUrl = async (jobId, fileName, contentType) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/getUploadInvoiceUrl?fileName=${fileName}&contentType=${contentType}`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const updatePrices = async (jobId, values) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/updatePrices`

  let requestBody = createRequestBody({
    method: 'PUT',
    body: values
  })
  return fetch(requestUrl, requestBody)
}

const updatePaymentInfo = async (jobId, paymentInfo) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/updatePaymentInfo`

  const requestBody = createRequestBody({
    method: 'PUT',
    body: paymentInfo
  })
  return fetch(requestUrl, requestBody)
}

const getItems = async (itemName, storeReference, source, jobReference) => {
  let requestUrl = `${API_URL_AVT}/antman/api/2020-08-06/admin/items/replacements?item=${itemName}`

  if (storeReference) {
    requestUrl += `&store_reference=${storeReference}`
  }

  if (source) {
    requestUrl += `&source=${source}`
  }

  if (jobReference) {
    requestUrl += `&job_reference=${jobReference}`
  }

  let requestBody = createRequestBody({
    method: 'GET'
  })

  return fetch(requestUrl, requestBody)
}

const updateItem = async (jobId, itemId, body) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/products/${itemId}`

  let requestBody = createRequestBody({
    method: 'PUT',
    body
  })
  return fetch(requestUrl, requestBody)
}

const removeItem = async (jobId, itemId) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/products/${itemId}`

  let requestBody = createRequestBody({
    method: 'POST'
  })
  return fetch(requestUrl, requestBody)
}

const getItemChanges = (jobId) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/item-changes`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getItemByJob = (jobId) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/items`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const sendRejectProducts = async (jobId, items) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/rejectProducts/v2`

  let headers = {
    method: 'POST',
    body: { items_to_reject: items }
  }
  let requestBody = createRequestBody(headers)
  return fetch(requestUrl, requestBody)
}

const sendUndoRejection = async (jobId, items) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/undoRejection`

  let headers = {
    method: 'POST',
    body: { items_to_undo_rejection: items }
  }
  let requestBody = createRequestBody(headers)
  return fetch(requestUrl, requestBody)
}

const availability = async (jobId, start, end, jobItems) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/availability/v2`

  let requestBody = await createRequestBody({
    method: 'POST',
    body: { start, end, jobItems }
  })
  return fetch(requestUrl, requestBody)
}

const createIssue = async (jobId, slotId, comment, reasonType, reasonId, id, prices) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/createJobV2`

  let requestBody = await createRequestBody({
    method: 'POST',
    body: { jobId, slotId, comment, reasonType, reasonId, id, prices }
  })
  return fetch(requestUrl, requestBody)
}

const getSlotsAvailabilityRescheduleDeprecated = async (jobId) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/reschedule/availability/${jobId}`

  let requestBody = await createRequestBody({
    method: 'POST',
    body: { jobId }
  })
  return fetch(requestUrl, requestBody)
}

const getSlotsAvailabilityRescheduleV1 = async (jobId, data) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/slots-availability`

  let requestBody = await createRequestBody({
    method: 'POST',
    body: data
  })
  return fetch(requestUrl, requestBody)
}

const createReschedule = async (jobId, { from, to }, comment, backToStorage, reasonId, reasonType, id, otherReason) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/reschedule/v2`

  let requestBody = await createRequestBody({
    method: 'PUT',
    body: {
      jobId,
      from,
      to,
      back_to_storage: backToStorage,
      comment,
      reasonType,
      reasonId: reasonId,
      id,
      otherReason
    }
  })
  return fetch(requestUrl, requestBody)
}

const cancelJob = async (jobId, comment, reasonId, reasonType, id, otherReason) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/cancel`

  let requestBody = await createRequestBody({
    method: 'POST',
    body: {
      reasonComment: comment,
      reasonId,
      reasonType,
      id,
      params: { comment },
      otherReason
    }
  })
  return fetch(requestUrl, requestBody)
}

const getReasons = async (type) => {
  const requestUrl = `${API_URL_AVT}/odin/api/reasons?type=${type}`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const downloadEvent = async (uuid, eventName) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${uuid}/downloadEvent/${eventName}`

  const requestBody = await createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

export {
  getFlags,
  resolveFlag,
  getHistory,
  cancelJob,
  resetTask,
  assignTask,
  reAssignTask,
  resetDeliveryTries,
  makeDelivery,
  getPhotoUrl,
  getInvoices,
  downloadInvoices,
  getUploadInvoiceUrl,
  updatePrices,
  updatePaymentInfo,
  getItems,
  updateItem,
  removeItem,
  getItemChanges,
  sendRejectProducts,
  sendUndoRejection,
  availability,
  createIssue,
  getSlotsAvailabilityRescheduleDeprecated,
  getSlotsAvailabilityRescheduleV1,
  createReschedule,
  getItemByJob,
  downloadEvent,
  blockingPolicyUnlock,
  getReasons,
  changeOptimalStartTask,
  getDeliveryValidationsImages,
  downloadDeliveryValidationsImages
}
